document.addEventListener("DOMContentLoaded", function () {
  console.log("DOM fully loaded and parsed");

  // Identify the section element
  const relatedSection = document.querySelector('[data-section-id][data-diameter]');
  if (!relatedSection) {
    console.error("No related section found.");
    return;
  }

  // Hide debug info (if any) but leave main elements visible
  const debugInfoElement = relatedSection.querySelector('.debug-info');
  if (debugInfoElement) {
    debugInfoElement.style.display = 'none'; // Only hide debug info
  }

  const currentDiameter = parseFloat(relatedSection.getAttribute('data-diameter'));
  if (isNaN(currentDiameter)) {
    console.error("Invalid or missing 'data-diameter' attribute.");
    return;
  }

  const tolerance = parseFloat(relatedSection.getAttribute('data-tolerance')) || 50;
  const limit = parseInt(relatedSection.getAttribute('data-limit')) || 10;

  console.log("Current Diameter:", currentDiameter);
  console.log("Tolerance:", tolerance);
  console.log("Limit:", limit);

  console.log("Starting fetch to related products collection...");

  fetch("https://www.tyredispatch.co.nz/collections/related-tyres-by-diameter?view=json")
    .then(response => {
      console.log("Fetch response status:", response.status);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(data => {
      console.log("Received data:", data);

      if (!data.products || !Array.isArray(data.products)) {
        console.error("Invalid data format received. Expected an array of products.");
        return;
      }

      const products = data.products;
      const filteredProducts = products.filter(product => {
        const productDiameter = parseFloat(product.metafields?.custom?.diameter);
        if (isNaN(productDiameter)) {
          console.warn(`Product ID ${product.id} has an invalid diameter value:`, product.metafields?.custom?.diameter);
          return false;
        }

        const isWithinTolerance = Math.abs(productDiameter - currentDiameter) <= tolerance;
        const isDifferentProduct = product.id !== parseInt(relatedSection.getAttribute('data-product-id'));

        return isDifferentProduct && isWithinTolerance;
      }).sort((a, b) => Math.abs(a.metafields?.custom?.diameter - currentDiameter) - Math.abs(b.metafields?.custom?.diameter - currentDiameter)).slice(0, limit);

      console.log("Filtered products:", filteredProducts);

      // Enhanced product loop container selector
      const productLoopContainer = relatedSection.querySelector('.glider.loading');
      if (!productLoopContainer) {
        console.error("Product loop container with class '.glider.loading' not found in the related section.");
        return;
      }

      // Ensure product loop container is visible and remove existing placeholder products
      productLoopContainer.style.display = 'block';
      productLoopContainer.style.opacity = '1';
      productLoopContainer.innerHTML = ''; // Clear placeholders

      // Add a section title if filtered products are available
      if (filteredProducts.length > 0) {
        filteredProducts.forEach(product => {
          console.log("Processing product:", product); // Debug: log each product details to inspect values

          // Handle image URL (if URL is relative, add protocol)
          let imageUrl = product.featured_image;
          if (imageUrl && !imageUrl.startsWith('http')) {
            imageUrl = `https:${imageUrl}`; // Add protocol if missing
          }

          // Extract price from the first variant, or set as unavailable
          const variant = product.variants ? product.variants[0] : null;
          const productPrice = variant && variant.price
            ? `$${(variant.price / 100).toFixed(2)}` // Assuming price is in cents
            : "Price Unavailable";

          // JavaScript code snippet for the HTML structure generation
          const productHTML = `
            <div class="product-border product-border-background text-left product animate borders three loading brands">
              <a href="${product.url}" class="product-link">
                <div class="product-thumb-container">
                  <div class="product-thumb">
                    <img src="${imageUrl}" alt="${product.title}" class="product-thumb-image">
                  </div>
                </div>
                <div class="product-details">
                  <div class="product-title">
                    <h5>${product.title}</h5>
                  </div>
                  <div class="product-price">
                    <h6>${productPrice}</h6>
                  </div>
                  <div class="product-meta">
                    <p class="product-diameter">Diameter: ${product.metafields.custom.diameter || "N/A"} mm</p>
                    <p class="product-width">Width: ${product.metafields.custom.width ? product.metafields.custom.width + " mm" : "N/A"}</p>
                    <p class="product-sidewall">Sidewall: ${product.metafields.custom.sidewall || "N/A"} mm</p>
                    <p class="product-rim-size">Rim Size: ${product.metafields.custom.rim_in_ || "N/A"} inches</p>
                    <p class="product-pattern-type">${product.metafields.custom.pattern_type || ""}</p>
                  </div>
                  <span class="purchase">
                    <span class="button-common">
                      <span class="btn auto-width">Quick Shop</span>
                    </span>
                  </span>
                </div>
              </a>
            </div>
          `;
          
          // Insert the generated HTML into the container
          productLoopContainer.insertAdjacentHTML('beforeend', productHTML);
        });
      } else {
        productLoopContainer.innerHTML = "<p>No related products found within the tolerance range.</p>";
      }

    })
    .catch(error => {
      console.error("Error fetching related products:", error);
      const productLoopContainer = relatedSection.querySelector('.glider.loading');
      if (productLoopContainer) {
        productLoopContainer.innerHTML = "<p>Error loading related products.</p>";
      }
    });
});























